import { render } from "./OptionsManage.vue?vue&type=template&id=1b016555&scoped=true"
import script from "./OptionsManage.vue?vue&type=script&lang=js"
export * from "./OptionsManage.vue?vue&type=script&lang=js"

import "./OptionsManage.vue?vue&type=style&index=0&id=1b016555&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b016555"]])

export default __exports__